import { FilterIcon } from 'lucide-react';
import React from 'react';
import { useCandidatesOverviewContext } from '../../Contexts/CandidatesOverviewContext/CandidatesOverviewContext';
import { Button } from '@/Components/shadcn';
import { cn } from '@/lib/utils';

function ToolbarFilterButton() {
    const { openFilter, toggleOpenFilter } = useCandidatesOverviewContext();

    return (
        <Button
            variant="ghost"
            size="icon"
            onClick={toggleOpenFilter}
            data-cy="ToolbarFilterButton"
            aria-expanded={openFilter}
            aria-pressed={openFilter}
            type="button"
            className={cn(openFilter ? 'bg-accent text-primary' : 'text-muted-foreground')}
        >
            <FilterIcon />
        </Button>
    );
}

export default ToolbarFilterButton;
